<template>
  <div class="modal-container" v-if="visible">
    <div class="modal">
      <h4 class="modal__title">{{ $t("sale") }}</h4>
      <a @click="hideModal"
        ><v-icon name="times" scale="1.6" class="modal__close-icon"
      /></a>
      <form class="modal__form" @submit.prevent="submitForm">
        <div class="modal__form-item">
          <label class="modal__label">ISIN</label>
          <input
            type="text"
            class="modal__input modal__input_connected"
            style="width:190px"
            v-model="isin"
            required
          />
          <button
            type="button"
            class="modal__search-button button filled"
            @click="findItem"
          >
            {{ $t("search") }}
          </button>
        </div>
        <div class="modal__form-item">
          <label class="modal__label">{{ $t("issuer") }}</label>
          <input
            type="text"
            class="modal__input"
            disabled
            v-model="issuer"
            required
          />
        </div>
        <div class="modal__form-item">
          <label class="modal__label">{{ $t("security name") }}</label>
          <input
            type="text"
            class="modal__input"
            disabled
            v-model="name"
            required
          />
        </div>
        <div class="modal__form-item">
          <label class="modal__label">{{ $t("currency") }}</label>
          <input
            type="text"
            class="modal__input"
            disabled
            v-model="currency"
            required
          />
        </div>
        <div class="modal__form-item">
          <label class="modal__label">{{ $t("ask") }}</label>
          <input
            type="text"
            class="modal__input"
            disabled
            v-model="ask"
            required
          />
        </div>
        <div class="modal__form-item">
          <label class="modal__label">{{ $t("bid") }}</label>
          <input
            type="text"
            class="modal__input"
            disabled
            v-model="bid"
            required
          />
        </div>
        <div class="modal__form-item">
          <label class="modal__label">{{ $t("price") }}</label>
          <input type="text" class="modal__input" v-model="price" required />
        </div>
        <div class="modal__form-item">
          <label class="modal__label">{{ $t("amount") }}</label>
          <input type="text" class="modal__input" v-model="amount" required />
        </div>
        <div class="modal__form-item">
          <label class="modal__label">{{ $t("date of expiration") }}</label>
          <input
            type="date"
            class="modal__input"
            name="expiration_date"
            v-model="expiration_date"
            required
          />
          <input type="hidden" v-model="type" />
        </div>

        <button type="submit" class="modal__submit-button button filled">
          {{ $t("sell securities") }} ( {{ totalSum }} ₸ )
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import "vue-awesome/icons";
import Icon from "vue-awesome/components/Icon";
import { FhsAxios } from "../../services/axios";
import user from "@/store/modules/user.js";
import FhsCookies from "../../services/cookies";
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isin: "",
      issuer: "",
      name: "",
      currency: "",
      ask: "",
      bid: "",
      price: "",
      amount: 1,
      expiration_date: "",
      type: 2
    };
  },
  components: {
    "v-icon": Icon
  },
  computed: {
    totalSum() {
      return this.amount * this.price;
    }
  },
  methods: {
    findItem() {
      // sry
      FhsAxios.get("/reuters/securities/" + this.isin, {
        data: {}
      })
        .then(response => {
          let result = response.data.result;

          this.issuer = result.issuer.name;
          this.name = result.name;
          this.currency = result.currency;
        })
        .catch(e => {
          console.log(e);
        });

      //double sry
      FhsAxios.get("/reuters/quote/" + this.isin, {
        data: {}
      })
        .then(response => {
          let result = response.data.result;
          this.ask = result.ask;
          this.bid = result.bid;
        })
        .catch(e => {
          console.log(e);
        });
    },
    hideModal() {
      this.$emit("hideModal");
    },
    submitForm() {
      FhsAxios.post("orders/create-order", this._data)
        .then(response => {
          this.hideModal();
          if (response.data.result == true) {
            alert("Приказ создан");
          } else {
            alert("Ошибка при создании приказа");
          }
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>

<style scoped>
.modal {
  width: 448px;
}

.modal__form {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
}

.modal__form-item {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.modal__form-item:not(:first-child) {
  margin-top: 15px;
}

.modal__label {
  max-width: 130px;
  font-size: 15px;
  margin: 0px 20px 0px 0px;
}

.modal__input {
  width: 250px;
  padding: 10px 12px;
  color: #222c44;
  border: 1px solid #acb5c5;
  border-radius: 5px;
}

.modal__submit-button {
  margin-top: 40px;
  padding: 15px 20px;
  align-self: flex-end;
  justify-self: flex-end;
}
.modal__search-button {
  padding: 10px;
  align-self: flex-end;
  justify-self: flex-end;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
}
.modal__input_connected {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
</style>
